import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ElDialog} from 'element-plus';
import { MaterialResPlayer } from '@yanxiu/player';
import {reactive} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewMaterial',
  props: {
    visible: {
        type: Boolean,
        default: false
    },
    fileData: {
        type: Object,
        default: () => ({})
    }
},
  emits: ['update:visible'],
  setup(__props, { emit }) {

const props = __props;




const COURSE_WIDTH = 900;
const COURSE_HEIGHT = 598;

let playerConf = reactive({
    width: COURSE_WIDTH,
    height: COURSE_HEIGHT
});

const handleClose = () => {
    emit('update:visible', false);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElDialog), {
    title: __props.fileData.materialFullName,
    "model-value": __props.visible,
    "close-on-click-modal": false,
    width: _unref(playerConf).width+40,
    onClose: handleClose,
    "destroy-on-close": "",
    class: "mater-dialog"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(MaterialResPlayer), {
        material: props.fileData,
        withFullScreen: "",
        "video-options": {
                autoplay: false,
                controlBar: {pictureInPictureToggle: false}
            },
        downloadable: "",
        width: _unref(playerConf).width
      }, null, 8, ["material", "width"])
    ]),
    _: 1
  }, 8, ["title", "model-value", "width"]))
}
}

})